import QuestionArray from '@/components/Question/QuestionArray';
import {ERRORS_TOTAL_LIMIT} from '@/components/Question/Question';

export default class Result {
    get errorsCount(): number {
        return this._errorsCount;
    }

    get answersCount(): number {
        return this._answersCount;
    }

    get title(): string {
        return this._title;
    }

    get time(): string {
        return this._time;
    }

    get questions(): QuestionArray {
        return this._questions;
    }

    get date(): Date {
        return this._date;
    }

    private readonly _questions: QuestionArray;
    private readonly _time: string;
    private readonly _title: string;
    private readonly _date: Date;
    private readonly _errorsCount: number;
    private readonly _answersCount: number;

    public constructor(questions: QuestionArray, time: string, title: string, errors: number, answered: number, date?: string) {
        this._questions = questions;
        this._time = time;
        this._title = title;
        this._errorsCount = errors;
        this._answersCount = answered;

        if (date) {
            this._date = new Date(date);
        } else {
            this._date = new Date();
        }
    }

    public get dateString(): string {
        return `${this._date.getDate()}.${this._date.getMonth() + 1}.${this._date.getFullYear()} ${this.hours}:${this.minutes}`;
    }

    private get hours(): string {
        const hours: number = this._date.getHours();

        if (hours < 10) {
            return `0${hours}`;
        } else return '' + hours;
    }

    private get minutes(): string {
        const min: number = this._date.getMinutes();

        if (min < 10) {
            return `0${min}`;
        } else return '' + min;
    }

    get right(): number {
        return parseInt(((this._answersCount - this._errorsCount) / this._questions.length * 100).toString(), 0);
    }

    get status(): boolean {
        return this._answersCount === this._questions.length && this._errorsCount < ERRORS_TOTAL_LIMIT;
    }
}